import get from 'lodash/get'
import { IOption } from 'types/common'
import {
  createDecisionPointMedias,
  createDecisionPoints,
  createDecisionPointSteps,
  dropDecisionPoint,
  dropDecisionPointMedia,
  dropDecisionPointStep
} from 'API/decisionPoint'
import {
  IDecisionPoint,
  IDecisionPointLinkForm,
  IDecisionPointMedia,
  IDecisionPointStep,
  IDecisionPointWithRelations
} from 'interfaces/decisionPoint'
import { IMedia } from 'interfaces/media'
import { ITextContentWithRelations } from 'interfaces/textContent'

export async function createDecisionPoint(getValues: () => any, textContentsId: number): Promise<void> {
  const formValues = getValues()
  const decisionPointsForm: IDecisionPointLinkForm[] = get(formValues, 'decisionPoints', []) || []

  const desitionPoints = decisionPointsForm?.map((formValue: IDecisionPointLinkForm, index: number) => {
    const decisionPoint = {
      title: formValue?.content,
      textContentsId,
      position: index
    }
    return decisionPoint
  })

  const newDecisionPoints = await createDecisionPoints(desitionPoints)

  const decisionPointStepArr: IDecisionPointStep[] = []
  const decisionPointMediaArr: IDecisionPointMedia[] = []

  newDecisionPoints.forEach((createdDecisionPoint: IDecisionPoint, i: number) => {
    const formValue = formValues.decisionPoints[i]
    const linkedSteps: IDecisionPointStep[] =
      formValue?.linkedSteps?.map((linkedStep: IOption<number>) => {
        const decisionPointStep: IDecisionPointStep = {
          decisionPointId: Number(createdDecisionPoint.id),
          stepId: linkedStep.value
        }
        return decisionPointStep
      }) ?? []

    const linkedMedias: IDecisionPointMedia[] =
      formValue?.linkedMedia?.map((linkedMedia: IMedia) => {
        const decisionPointMedia: IDecisionPointMedia = {
          decisionPointId: Number(createdDecisionPoint.id),
          mediaId: linkedMedia.id
        }
        return decisionPointMedia
      }) ?? []

    decisionPointStepArr.push(...linkedSteps)
    decisionPointMediaArr.push(...linkedMedias)
  })

  await createDecisionPointSteps(decisionPointStepArr)
  await createDecisionPointMedias(decisionPointMediaArr)
}

export async function clearOldDecisionPoint(blockText: ITextContentWithRelations): Promise<void> {
  if (!Array.isArray(blockText?.decisionPoints)) return

  await Promise.all(
    blockText?.decisionPoints?.map((decisionPoint: IDecisionPointWithRelations) => {
      const textContentsId = decisionPoint?.textContentsId
      let dropDecisionPointPromises = {}

      if (textContentsId) {
        dropDecisionPointPromises = dropDecisionPoint(textContentsId)
      }

      const dropDecisionPointMediaPromises = dropDecisionPointMedia(decisionPoint.id!)
      const dropDecisionPointStepPromises = dropDecisionPointStep(decisionPoint.id!)

      return Promise.all([dropDecisionPointMediaPromises, dropDecisionPointStepPromises, dropDecisionPointPromises])
    })
  )
}
